import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getDefaultTCG, getEnabledTCGs, getTCGConfig } from '../config/tcg';

// Create a Zustand store for TCG state
export const useTCGStore = create(
  persist(
    (set, get) => ({
      // Initialize with the default TCG
      activeTCG: getDefaultTCG().id,
      
      // Set the active TCG
      setActiveTCG: (tcgId) => {
        // Validate that the TCG is supported and enabled
        const enabledTCGs = getEnabledTCGs();
        const isValidTCG = enabledTCGs.some(tcg => tcg.id === tcgId);
        
        if (isValidTCG) {
          set({ activeTCG: tcgId });
          return true;
        }
        
        return false;
      },
      
      // Get the active TCG object
      getActiveTCGObject: () => {
        const { activeTCG } = get();
        return getEnabledTCGs().find(tcg => tcg.id === activeTCG) || getDefaultTCG();
      },
      
      // Get configuration for the active TCG
      getActiveTCGConfig: () => {
        const { activeTCG } = get();
        return getTCGConfig(activeTCG);
      },
    }),
    {
      name: 'TCGStacked.TCG',
    }
  )
);

// Hook for using TCG functionality
export const useTCG = () => {
  const { activeTCG, setActiveTCG, getActiveTCGObject, getActiveTCGConfig } = useTCGStore();
  
  // Get all enabled TCGs
  const enabledTCGs = getEnabledTCGs();
  
  // Get the active TCG object
  const activeTCGObject = getActiveTCGObject();
  
  // Get configuration for the active TCG
  const activeTCGConfig = getActiveTCGConfig();
  
  return {
    activeTCG,
    setActiveTCG,
    enabledTCGs,
    activeTCGObject,
    activeTCGConfig,
  };
};
